// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*\n * Menu css File\n*/\n.Menu {\n  /* propertys here */\n}", "",{"version":3,"sources":["webpack://src/Components/Menu/Menu.scss"],"names":[],"mappings":"AAAA;;CAAA;AAIA;EACI,mBAAA;AAAJ","sourcesContent":["/*\n * Menu css File\n*/\n\n.Menu {\n    /* propertys here */\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
